import { render, staticRenderFns } from "./Inspired.vue?vue&type=template&id=aa7bd8a0"
import script from "./Inspired.vue?vue&type=script&lang=js"
export * from "./Inspired.vue?vue&type=script&lang=js"
import style0 from "./Inspired.vue?vue&type=style&index=0&id=aa7bd8a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports